import useUsers from "hooks/users/useUsers";
import UserForm from "./Form";

export default function EditUser() {
  const { updateUser, user } = useUsers();
  return <UserForm user={user} onSubmit={updateUser} />;
}
